<script setup lang="ts">
  interface Props {
    hasExtra?: boolean;
    marginY?: number;
  }
  const props = withDefaults(defineProps<Props>(), {
    hasExtra: false,
    marginY: 0,
  });

  const heightToSubtract = props.hasExtra ? 208 + props.marginY : 152 + props.marginY;
  const wrapperHeight = `calc(100svh - ${heightToSubtract}px)`;
  const wrapperHeightSp = `calc(100svh - ${heightToSubtract + 20}px)`;
</script>

<template>
  <div class="menu_lists pl-2">
    <div class="menu_list_wrapper">
      <slot></slot>
    </div>

    <template v-if="hasExtra">
      <slot name="extra"></slot>
    </template>
  </div>
</template>

<style lang="scss" scoped>
  @import "assets/media.scss";

  .menu_lists {
    display: table-cell;
    width: 248px;
    min-width: 248px;
    background-color: #161616;
    @include display_sp {
      width: 100svw;
    }
    .menu_list_wrapper {
      height: v-bind(wrapperHeight);
      @include display_sp {
        height: v-bind(wrapperHeightSp);
      }
      overflow-y: scroll;
      // スクロールバーを非表示にする (以下の一式でクロスブラウザ対応)
      -ms-overflow-style: none;
      scrollbar-width: none;
      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
</style>
